
export const updateTournV2 = (tourn, message) => {
    if(message.frontEndId){
        tourn.frontEndId = message.frontEndId;
    }
    if(message.chlInfo!=null){
        tourn.isInteractiveServiceAvailable = message.chlInfo.filter(x=> x.chl == "InteractiveService")[0].st == "Available";
    }
    if(message.seq){
        tourn.sequence = message.seq;
    }
    if(message.st){
        tourn.status = message.st.toUpperCase();
    }
}